module.exports = require("zlib");


/*****************
 ** WEBPACK FOOTER
 ** external "zlib"
 ** module id = 338
 ** module chunks = 0
 **/